import axios from "axios";
import { axiosConfig } from "../../config/index";
import {
  EMPLOYEE_FETCHED,
  IMPORT_EMPLOYEES
} from "../types";

/**
 * Fetches all employees from the server.
 */
export const getAllEmployees = () => (dispatch: any) => {
  axios
    .get(`/api/employees/getallemployees`, axiosConfig)
    .then((res) => {
      dispatch({
        type: EMPLOYEE_FETCHED,
        employeeData: res.data,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

/**
 * Imports a batch of employees via CSV upload.
 */
export const importEmployees = (value: any) => (
  dispatch: any,
  getState: any
) => {
  const newEmployeesForm = new FormData();
  newEmployeesForm.append("employee", value.employee);

  return axios
    .put(`/api/employees/import`, newEmployeesForm, axiosConfig)
    .then((res) => {
      dispatch({
        type: IMPORT_EMPLOYEES,
        invalidEmployees: res.data.invalidEmployees,
      });
      dispatch(getAllEmployees());
      return Promise.resolve(true);
    })
    .catch((err) => {
      console.error("[EMPLOYEE] Import failed:", err?.response?.data || err.message);
      return Promise.reject(err);
    });
};
